import React from 'react';

function TwitterIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
      <path
        fill="#000"
        d="M.75 1.927h1.875l11.25 15H12l-11.25-15zm3.375 0H6l11.25 15h-1.875l-11.25-15zm-1.875 0H6v1.5H2.25v-1.5zm9.75 13.5h3.75v1.5H12v-1.5zm1.875-13.5H16.5l-12.75 15H1.125l12.75-15z"
      ></path>
    </svg>
  );
}

export default TwitterIcon;
